import { motion } from "framer-motion";

const pairs = [
  { them: "Google gives you 10 blue links", us: "We give you 1 clear winner" },
  { them: "Amazon ranks by ads and reviews", us: "We rank by real price, trust, and delivery" },
  { them: "ChatGPT guesses from training data", us: "We check real retailer data, not just training data" },
];

export default function WhyNotSearch() {
  return (
    <section className="py-10 sm:py-14 px-4 max-w-md mx-auto">
      <motion.h2
        initial={{ opacity: 0, y: 12 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.4 }}
        className="text-lg sm:text-xl font-display font-bold text-foreground text-center mb-6"
      >
        Why Decyzon
      </motion.h2>
      <div className="space-y-5">
        {pairs.map((p, i) => (
          <motion.div
            key={i}
            initial={{ opacity: 0, y: 8 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.3, delay: i * 0.06 }}
            className="text-center space-y-0.5"
          >
            <p className="text-sm font-body text-muted-foreground/50 line-through decoration-muted-foreground/20">{p.them}</p>
            <p className="text-[15px] font-body font-semibold text-foreground">{p.us}</p>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
